export const T = {
  en_GB: {
    viewChart: "View chart",
    allSources: "All sources",
    allStatuses: "All statuses",
    search: "Search",
    searchPlaceholder: "Search ticker, name or ISIN…",
    instrument: "Instrument",
    name: "Name",
    currency: "Currency",
    status: "Status",
    sync: "Sync",
    noInstruments: "No instruments found.",
    showingResults: (p: { from: string; to: string; total: string }) =>
      `Showing ${p.from}-${p.to} of ${p.total}`,
    previous: "Previous",
    next: "Next",
    pageOf: (page: string, totalPages: string) => `Page ${page} of ${totalPages}`,
    ok: "OK",
    noData: "No data",
    noCurrency: "No currency",
    stale: "Stale",
    syncDisabled: "Sync off",
    syncFailing: "Failing",
    fxMissing: "No FX rate",
    enableSync: "Enable sync — wipes and re-fetches full history",
    disableSync: "Disable sync",
    fxBannerTitle: "Missing FX rates",
    fxBannerBody: (count: string) =>
      `${count} instrument(s) use a currency with no USD FX pair, so they cannot be converted to a report currency — their snapshots fail. Backfill the currency in that environment (ensureCurrencyPair) to fix all of them at once.`,
    fxBannerShow: "Show them",
    viewData: "View data",
  },
  nb_NO: {
    viewChart: "Vis graf",
    allSources: "Alle kilder",
    allStatuses: "Alle statuser",
    search: "Søk",
    searchPlaceholder: "Søk ticker, navn eller ISIN…",
    instrument: "Instrument",
    name: "Navn",
    currency: "Valuta",
    status: "Status",
    sync: "Synk",
    noInstruments: "Ingen instrumenter funnet.",
    showingResults: (p: { from: string; to: string; total: string }) =>
      `Viser ${p.from}-${p.to} av ${p.total}`,
    previous: "Forrige",
    next: "Neste",
    pageOf: (page: string, totalPages: string) => `Side ${page} av ${totalPages}`,
    ok: "OK",
    noData: "Ingen data",
    noCurrency: "Ingen valuta",
    stale: "Utdatert",
    syncDisabled: "Synk av",
    syncFailing: "Feiler",
    fxMissing: "Mangler valutakurs",
    enableSync: "Slå på synk — sletter og henter full historikk på nytt",
    disableSync: "Slå av synk",
    fxBannerTitle: "Manglende valutakurser",
    fxBannerBody: (count: string) =>
      `${count} instrument(er) bruker en valuta uten USD-kurspar og kan ikke konverteres til en rapportvaluta — øyeblikksbildene feiler. Kjør valuta-backfill i miljøet (ensureCurrencyPair) for å fikse alle på én gang.`,
    fxBannerShow: "Vis dem",
    viewData: "Vis data",
  },
} as const;
